import type { ValueOf } from 'cpool-utils';

export const TooltipVariant = {
    DARK: 'dark',
    ERROR: 'error',
    LIGHT: 'light',
    WHITE: 'white',
} as const;

export type TooltipVariantType = ValueOf<typeof TooltipVariant>;

export const TooltipPosition = {
    BOTTOM: 'bottom',
    LEFT: 'left',
    RIGHT: 'right',
    TOP: 'top',
} as const;

export type TooltipPositionType = ValueOf<typeof TooltipPosition>;

export const TooltipSize = {
    BIG: 'big',
    SMALL: 'small',
} as const;

export type TooltipSizeType = ValueOf<typeof TooltipSize>;

export const TooltipAlign = {
    CENTER: 'center',
    END: 'end',
    START: 'start',
} as const;

export type TooltipAlignType = ValueOf<typeof TooltipAlign>;

export interface TooltipDelayConfig {
    delayHide?: number;
    delayShow?: number;
}
